import { API_DOMAIN } from '@constants';
import {
  LibApiType,
  type TourAlbumItem,
  type TourAlbumResp,
  type TourData,
  type TourItem,
} from '@types';
import { teamConfig } from '@utils/teamConfig';
import axios from '@utils/axios';

/**
 * 获取作品数据
 */
export function fetchTourData(tid: string) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tour/${tid}`,
    `${API_DOMAIN}/team/app/tours/${tid}`
  );
  return axios.get<TourData>(url);
}

/**
 * 获取漫游相册列表
 */
export function fetchTourAlbums({
  albumId = 0,
  sort = 0,
}: {
  albumId?: number;
  sort?: number;
}) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tour/albums`,
    `${API_DOMAIN}/team/app/tours/albums`
  );
  return axios.get<TourAlbumResp>(url, { params: { albumId, sort } });
}

/**
 * 获取全景漫游列表
 */
export function fetchTourItems({
  page = 1,
  albumId = 0,
  sort = 0,
}: {
  page?: number;
  albumId?: number;
  sort?: number;
}) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tours`,
    `${API_DOMAIN}/team/app/tours`
  );
  return axios.get<TourItem[]>(url, {
    params: { albumId, page, sort },
  });
}

/**
 * 搜索漫游相册
 */
export function searchTourAlbums({ query }: { query: string }) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tour/albums/search`,
    `${API_DOMAIN}/team/app/tours/albums/search`
  );
  return axios.get<TourAlbumItem[]>(url, {
    params: { content: query, type: LibApiType.other },
  });
}

/**
 * 搜索漫游作品
 */
export function searchTourItems({
  query,
  page = 1,
}: {
  query: string;
  page?: number;
}) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tours/search`,
    `${API_DOMAIN}/team/app/tours/search`
  );
  return axios.get<TourItem[]>(url, {
    params: { content: query, page, type: LibApiType.other },
  });
}

/**
 * 创建漫游相册
 */
export function createTourAlbum({
  name,
  parentId = 0,
}: {
  name: string;
  parentId?: number;
}) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tours/album`,
    `${API_DOMAIN}/team/app/tours/album`
  );
  return axios.post<{ albumId: number }>(url, { name, parentId });
}

/**
 * 跨作品复制
 */
export function sceneCopy({
  tid,
  category,
  scenes,
}: {
  tid: string;
  category: TourData['category'];
  scenes: TourData['scenes'];
}) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/tour/${tid}/scene/copy`,
    `${API_DOMAIN}/team/app/tours/${tid}/scene/copy`
  );
  return axios.post(url, {
    ...(category.length && { category: JSON.stringify(category) }),
    ...(scenes.length && { scenes: JSON.stringify(scenes) }),
  });
}
